/**
 *
 * @param arr Array of values
 * @returns Unique array of submitted values
 */
export function uniqArray<T>(arr: Array<T>) {
  return [...new Set(arr)]
}
